function initExseedPdpShell(root) {
  root.querySelectorAll('.exseed-pdp-shell[data-section-id]').forEach(function (sectionRoot) {
    function getHeaderOffset() {
      const fallbackOffset = parseInt(getComputedStyle(sectionRoot).getPropertyValue('--sticky-top')) || 140;

      const possibleHeaders = [
        document.querySelector('.shopify-section-group-header-group'),
        document.querySelector('sticky-header'),
        document.querySelector('.header-wrapper'),
        document.querySelector('#shopify-section-header'),
        document.querySelector('.section-header'),
        document.querySelector('header')
      ].filter(Boolean);

      let headerBottom = 0;

      possibleHeaders.forEach(function (el) {
        const rect = el.getBoundingClientRect();
        if (rect.height > 0) {
          headerBottom = Math.max(headerBottom, rect.bottom);
        }
      });

      const computedOffset = Math.max(fallbackOffset, Math.ceil(headerBottom) + 20);
      sectionRoot.style.setProperty('--computed-sticky-top', computedOffset + 'px');

      return computedOffset;
    }

    function syncFixedSidebarPosition() {
      const desktopMq = window.matchMedia('(min-width: 990px)');
      const rightCol = sectionRoot.querySelector('.exseed-pdp-shell__right');
      const sticky = rightCol ? rightCol.querySelector('.exseed-pdp-shell__sticky:not(.is-not-sticky)') : null;

      if (!rightCol || !sticky) return;

      if (!desktopMq.matches) {
        sticky.classList.remove('is-at-bottom');
        sticky.style.position = '';
        sticky.style.top = '';
        sticky.style.left = '';
        sticky.style.width = '';
        sticky.style.maxWidth = '';
        sticky.style.bottom = '';
        sectionRoot.style.removeProperty('--computed-sticky-top');
        return;
      }

      const stickyTop = getHeaderOffset();
      const rightRect = rightCol.getBoundingClientRect();
      const stickyHeight = sticky.offsetHeight;
      const availableHeight = rightRect.height - stickyTop;

      sticky.classList.remove('is-at-bottom');
      sticky.style.position = '';
      sticky.style.top = '';
      sticky.style.left = '';
      sticky.style.width = '';
      sticky.style.maxWidth = '';
      sticky.style.bottom = '';

      if (availableHeight > 0 && stickyHeight >= availableHeight) {
        sticky.classList.add('is-at-bottom');
      }

      sectionRoot.style.setProperty('--computed-sticky-top', stickyTop + 'px');
    }

    function updateLastMobileShellBlock() {
      const blocks = Array.from(sectionRoot.querySelectorAll('.exseed-pdp-shell__left-block[data-mobile-shell]'));
      blocks.forEach(function (block) {
        block.classList.remove('is-last-mobile-shell');
      });

      const shellBlocks = blocks.filter(function (block) {
        return block.getAttribute('data-mobile-shell') === 'true';
      });

      if (shellBlocks.length) {
        shellBlocks[shellBlocks.length - 1].classList.add('is-last-mobile-shell');
      }
    }

    updateLastMobileShellBlock();

    function initPressCarousels() {
      // Inject the keyframe once per page
      if (!document.getElementById('exseed-press-ticker-style')) {
        var tickerStyle = document.createElement('style');
        tickerStyle.id = 'exseed-press-ticker-style';
        tickerStyle.textContent =
          '@keyframes exseed-press-ticker{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}';
        document.head.appendChild(tickerStyle);
      }

      sectionRoot.querySelectorAll('[data-exseed-press-carousel]').forEach(function (carousel) {
        const viewport = carousel.querySelector('.exseed-pdp-shell__press-viewport');
        const track = carousel.querySelector('.exseed-pdp-shell__press-track');
        // Only select original slides, not previously injected clones
        const slides = Array.from(carousel.querySelectorAll('.exseed-pdp-shell__press-slide:not([data-press-clone])'));
        if (!viewport || !track || !slides.length) return;

        // Clean up any previous interval-based setup
        if (carousel._pressInterval) {
          clearInterval(carousel._pressInterval);
          carousel._pressInterval = null;
        }
        if (carousel._pressResizeHandler) {
          window.removeEventListener('resize', carousel._pressResizeHandler);
          carousel._pressResizeHandler = null;
        }

        // Remove clones from any previous init so we don't double-up on re-init
        track.querySelectorAll('[data-press-clone]').forEach(function (el) { el.remove(); });

        // Clear any inline styles left by the old implementation
        track.style.transform = '';
        track.style.transition = '';

        // Duplicate slides — the track is now 2× wide.
        // Animating translateX(0 → -50%) scrolls exactly one full set, then loops seamlessly.
        slides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('data-press-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });

        // Speed: ~3 s per logo, minimum 12 s total
        var duration = Math.max(12, slides.length * 3);

        // Apply the ticker
        track.style.display = 'flex';
        track.style.width = 'max-content';
        track.style.animation = 'exseed-press-ticker ' + duration + 's linear infinite';
        track.style.willChange = 'transform';

        // Clip the scrolling track
        viewport.style.overflow = 'hidden';

        // Pause on hover — guard against duplicate listeners on re-init
        if (!carousel._pressTickerBound) {
          carousel._pressTickerBound = true;
          carousel.addEventListener('mouseenter', function () {
            track.style.animationPlayState = 'paused';
          });
          carousel.addEventListener('mouseleave', function () {
            track.style.animationPlayState = 'running';
          });
        }
      });
    }

    sectionRoot.querySelectorAll('[data-exseed-peek-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var allSlides = Array.from(carousel.querySelectorAll('.exseed-pdp-shell__slide'));
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var progressLine = carousel.querySelector('[data-carousel-progress-line]');
      var autoplayToggleBtn = carousel.querySelector('[data-carousel-autoplay-toggle]');
      var playIcon = carousel.querySelector('[data-autoplay-icon-play]');
      var pauseIcon = carousel.querySelector('[data-autoplay-icon-pause]');

      if (!track || !allSlides.length) return;

      var autoplayEnabled = carousel.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay-speed'), 10) || 3000;

      var currentPosIndex = 0;
      var visibleSlides = [];
      var isTransitioning = false;
      var autoplayTimer = null;
      var touchStartX = 0;
      var touchDeltaX = 0;
      var transitionFallbackTimer = null;

      function getActiveVariantId() {
        var activeButton = sectionRoot.querySelector('[data-exseed-buybox] .exseed-pdp-shell__option.is-active');
        var fallbackVariantId = sectionRoot.getAttribute('data-initial-variant-id') || '';
        return activeButton ? activeButton.getAttribute('data-variant-id') : fallbackVariantId;
      }

      function filterSlidesByVariant(activeVariantId) {
        visibleSlides = [];
        allSlides.forEach(function (slide) {
          var ownerIds = slide.getAttribute('data-variant-owner-ids') || '';
          var isVariantImage = slide.getAttribute('data-is-variant-image') === 'true';
          var shouldShow = !isVariantImage || ownerIds.indexOf(',' + activeVariantId + ',') !== -1;
          slide.hidden = !shouldShow;
          slide.style.display = shouldShow ? '' : 'none';
          if (shouldShow) visibleSlides.push(slide);
        });
      }

      function buildClones() {
        track.querySelectorAll('[data-carousel-clone]').forEach(function (el) { el.remove(); });
        if (visibleSlides.length < 2) return;
        var firstClone = visibleSlides[0].cloneNode(true);
        var lastClone = visibleSlides[visibleSlides.length - 1].cloneNode(true);
        firstClone.setAttribute('data-carousel-clone', 'first');
        lastClone.setAttribute('data-carousel-clone', 'last');
        firstClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('aria-hidden', 'true');
        firstClone.classList.remove('is-active');
        lastClone.classList.remove('is-active');
        track.insertBefore(lastClone, visibleSlides[0]);
        var afterLast = visibleSlides[visibleSlides.length - 1].nextSibling;
        if (afterLast) {
          track.insertBefore(firstClone, afterLast);
        } else {
          track.appendChild(firstClone);
        }
      }

      function getOrderedSlides() {
        if (visibleSlides.length < 2) return visibleSlides.slice();
        var lastClone = track.querySelector('[data-carousel-clone="last"]');
        var firstClone = track.querySelector('[data-carousel-clone="first"]');
        return [lastClone].concat(visibleSlides).concat([firstClone]);
      }

      function getTranslateForPos(pos) {
        var ordered = getOrderedSlides();
        var el = ordered[pos];
        if (!el) return 0;
        return el.offsetLeft;
      }

      function setTranslate(translate, animate) {
        if (animate) {
          track.style.transition = '';
        } else {
          track.style.transition = 'none';
          track.getBoundingClientRect();
        }
        track.style.transform = 'translateX(-' + translate + 'px)';
      }

      function updateProgress(realOneBasedIndex) {
        if (!progressLine) return;
        var total = visibleSlides.length || 1;
        progressLine.style.transform = 'scaleX(' + (realOneBasedIndex / total) + ')';
      }

      function goTo(pos, animate) {
        currentPosIndex = pos;
        setTranslate(getTranslateForPos(pos), animate);
        var realIdx = visibleSlides.length >= 2 ? pos - 1 : pos;
        if (realIdx >= 0 && realIdx < visibleSlides.length) {
          allSlides.forEach(function (s) { s.classList.remove('is-active'); });
          visibleSlides[realIdx].classList.add('is-active');
          updateProgress(realIdx + 1);
        }
      }

      function clearTransitionFallback() {
        if (transitionFallbackTimer) {
          clearTimeout(transitionFallbackTimer);
          transitionFallbackTimer = null;
        }
      }

      function scheduleTransitionFallback() {
        clearTransitionFallback();
        transitionFallbackTimer = setTimeout(function () {
          isTransitioning = false;
          transitionFallbackTimer = null;
          if (visibleSlides.length >= 2) {
            var total = visibleSlides.length;
            if (currentPosIndex === total + 1) {
              goTo(1, false);
            } else if (currentPosIndex === 0) {
              goTo(total, false);
            }
          }
        }, 600);
      }

      function next() {
        if (isTransitioning || visibleSlides.length < 2) return;
        isTransitioning = true;
        scheduleTransitionFallback();
        goTo(currentPosIndex + 1, true);
      }

      function prev() {
        if (isTransitioning || visibleSlides.length < 2) return;
        isTransitioning = true;
        scheduleTransitionFallback();
        goTo(currentPosIndex - 1, true);
      }

      track.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'transform') return;
        clearTransitionFallback();
        isTransitioning = false;
        if (visibleSlides.length < 2) return;
        var total = visibleSlides.length;
        if (currentPosIndex === total + 1) {
          goTo(1, false);
        } else if (currentPosIndex === 0) {
          goTo(total, false);
        }
      });

      function startAutoplay() {
        stopAutoplay();
        if (!autoplayEnabled || visibleSlides.length < 2) return;
        autoplayTimer = setInterval(function () { next(); }, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      }

      function updateAutoplayUI() {
        if (playIcon) playIcon.style.display = autoplayEnabled ? 'none' : '';
        if (pauseIcon) pauseIcon.style.display = autoplayEnabled ? '' : 'none';
        if (autoplayToggleBtn) autoplayToggleBtn.setAttribute('aria-pressed', String(autoplayEnabled));
      }

      if (autoplayToggleBtn) {
        autoplayToggleBtn.addEventListener('click', function () {
          autoplayEnabled = !autoplayEnabled;
          updateAutoplayUI();
          if (autoplayEnabled) { startAutoplay(); } else { stopAutoplay(); }
        });
      }

      carousel.addEventListener('mouseenter', function () { stopAutoplay(); });
      carousel.addEventListener('mouseleave', function () { if (autoplayEnabled) startAutoplay(); });

      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        stopAutoplay();
      }, { passive: true });

      carousel.addEventListener('touchmove', function (e) {
        touchDeltaX = e.touches[0].clientX - touchStartX;
      }, { passive: true });

      carousel.addEventListener('touchend', function () {
        if (Math.abs(touchDeltaX) > 50) {
          if (touchDeltaX < 0) { next(); } else { prev(); }
        }
        touchDeltaX = 0;
        if (autoplayEnabled) startAutoplay();
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stopAutoplay();
          prev();
          if (autoplayEnabled) startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stopAutoplay();
          next();
          if (autoplayEnabled) startAutoplay();
        });
      }

      window.addEventListener('resize', function () {
        setTranslate(getTranslateForPos(currentPosIndex), false);
      });

      window.addEventListener('load', function () {
        setTranslate(getTranslateForPos(currentPosIndex), false);
      });

      function syncVariantSlides(activeVariantId, preferredMediaId) {
        filterSlidesByVariant(activeVariantId);
        buildClones();

        var targetRealIdx = 0;
        if (preferredMediaId) {
          var found = visibleSlides.findIndex(function (slide) {
            return slide.getAttribute('data-media-id') === String(preferredMediaId);
          });
          if (found >= 0) targetRealIdx = found;
        }

        currentPosIndex = visibleSlides.length >= 2 ? targetRealIdx + 1 : targetRealIdx;

        setTranslate(getTranslateForPos(currentPosIndex), false);
        allSlides.forEach(function (s) { s.classList.remove('is-active'); });
        if (visibleSlides[targetRealIdx]) visibleSlides[targetRealIdx].classList.add('is-active');
        updateProgress(targetRealIdx + 1);
        carousel.classList.add('is-ready');

        updateAutoplayUI();
        stopAutoplay();
        if (autoplayEnabled) startAutoplay();
      }

      carousel.exseedSetVariantMedia = function (variantId, mediaId) {
        syncVariantSlides(String(variantId), mediaId);
      };

      var initialMediaId = sectionRoot.getAttribute('data-initial-media-id') || '';
      syncVariantSlides(getActiveVariantId(), initialMediaId);
    });

    function rebindCartDrawerUI() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.onclick = function () {
          if (typeof drawer.close === 'function') {
            drawer.close();
          } else {
            drawer.classList.remove('active', 'animate');
            document.body.classList.remove('overflow-hidden');
          }
        };
      }

      drawer.querySelectorAll('.drawer__close').forEach(function (btn) {
        btn.onclick = function () {
          if (typeof drawer.close === 'function') {
            drawer.close();
          } else {
            drawer.classList.remove('active', 'animate');
            document.body.classList.remove('overflow-hidden');
          }
        };
      });
    }

    function openCartDrawer(triggerEl) {
      const drawer = document.querySelector('cart-drawer');

      if (!drawer) {
        window.location.href = '/cart';
        return;
      }

      if (typeof drawer.open === 'function') {
        drawer.open(triggerEl);
        return;
      }

      drawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');

      const overlay = drawer.querySelector('#CartDrawer-Overlay') || document.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.onclick = function () {
          drawer.classList.remove('active', 'animate');
          document.body.classList.remove('overflow-hidden');
        };
      }
    }
  

    async function submitToCart(form, action) {
      if (!form) return;

      const submitButton = form.querySelector('[type="submit"]');
      const drawer = document.querySelector('cart-drawer');

      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('loading');
      }

      try {
        const formData = new FormData(form);

        if (drawer && action !== 'cart_page') {
          if (typeof drawer.getSectionsToRender === 'function') {
            const sectionIds = drawer.getSectionsToRender().map(function (section) {
              return section.id;
            }).join(',');

            formData.set('sections', sectionIds);
          }

          formData.set('sections_url', window.location.pathname);

          if (typeof drawer.setActiveElement === 'function') {
            drawer.setActiveElement(submitButton);
          }
        }

        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to Cart failed');
        }

        if (action === 'cart_page') {
          window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data);
          setTimeout(function () {
            rebindCartDrawerUI();
          }, 0);
        } else if (drawer) {
          openCartDrawer(submitButton);
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        console.error('[ExSeed ATC]', error);
        form.submit();
      } finally {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        }
      }
    }

    function initBuybox(buybox) {
      const optionButtons = buybox.querySelectorAll('.exseed-pdp-shell__option');
      const titleTarget = buybox.querySelector('[data-selected-title]');
      const priceTarget = buybox.querySelector('[data-selected-price]');
      const saveTarget = buybox.querySelector('[data-selected-save]');
      const perTestTarget = buybox.querySelector('[data-selected-per-test]');
      const perTestWrapper = buybox.querySelector('[data-selected-per-test-wrapper]');
      const featuresTarget = buybox.querySelector('[data-selected-features]');
      const variantInput = buybox.querySelector('[data-selected-variant-id]');
      const form = buybox.querySelector('form');
      const productForm = buybox.querySelector('.product-form');
      const paymentTermsContainer = buybox.querySelector('[data-payment-terms-container]');
      const submitButton = buybox.querySelector('.exseed-pdp-shell__submit');
      const submitLabel = buybox.querySelector('[data-add-to-cart-label]');
      const carousel = sectionRoot.querySelector('[data-exseed-peek-carousel]');

      if (!productForm) return;

      const addToCartText = productForm.getAttribute('data-add-to-cart-text') || 'Add to Cart';
      const soldOutText = productForm.getAttribute('data-sold-out-text') || 'Sold out';
      const addToCartAction = productForm.getAttribute('data-add-to-cart-action') || 'drawer';

      const fallbackFeatures = [
        productForm.getAttribute('data-default-feature-1') || '',
        productForm.getAttribute('data-default-feature-2') || '',
        productForm.getAttribute('data-default-feature-3') || '',
        productForm.getAttribute('data-default-feature-4') || ''
      ].filter(Boolean);
      const featureBulletIcon = productForm.getAttribute('data-feature-bullet-icon') || '';

      function getFeaturePrefixHtml() {
        if (featureBulletIcon) {
          return '<img class="exseed-pdp-shell__feature-icon" src="' + featureBulletIcon + '" alt="" width="16" height="16">';
        }
        return '<span class="exseed-pdp-shell__tick">&#9675;</span>';
      }

      function renderFeatures(featuresHtml, target) {
        if (!target) return;

        target.innerHTML = '';
        let rendered = false;
        const prefixHtml = getFeaturePrefixHtml();
        let campaignFeatures = [];
        const campaignFeaturesJson = target.getAttribute('data-dlp-campaign-features');
        if (campaignFeaturesJson) {
          try {
            campaignFeatures = JSON.parse(campaignFeaturesJson).filter(function (text) {
              return text != null && String(text).trim() !== '';
            });
          } catch (error) {
            campaignFeatures = [];
          }
        }

        if (campaignFeatures.length) {
          campaignFeatures.forEach(function (text) {
            const row = document.createElement('div');
            row.className = 'exseed-pdp-shell__feature';
            row.innerHTML = prefixHtml + '<span></span>';
            row.querySelector('span:last-child').textContent = String(text);
            target.appendChild(row);
          });
          rendered = true;
        } else if (featuresHtml) {
          const decoded = featuresHtml
            .replaceAll('&lt;br /&gt;', '<br />')
            .replaceAll('&lt;br&gt;', '<br>')
            .replaceAll('&amp;', '&');

          decoded.split(/<br\s*\/?>/).forEach(function (line) {
            const text = line.trim();
            if (!text) return;

            const row = document.createElement('div');
            row.className = 'exseed-pdp-shell__feature';
            row.innerHTML = prefixHtml + '<span>' + text + '</span>';
            target.appendChild(row);
            rendered = true;
          });
        }

        if (!rendered && fallbackFeatures.length) {
          fallbackFeatures.forEach(function (text) {
            const row = document.createElement('div');
            row.className = 'exseed-pdp-shell__feature';
            row.innerHTML = prefixHtml + '<span>' + text + '</span>';
            target.appendChild(row);
          });
          rendered = true;
        }

        target.classList.toggle('is-hidden', !rendered);
      }

      function refreshPaymentTerms() {
        if (!form || !paymentTermsContainer) return;
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          idInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function updateSubmitButtonState(isAvailable) {
        if (!submitButton || !submitLabel) return;

        if (isAvailable) {
          submitButton.removeAttribute('disabled');
          submitLabel.textContent = addToCartText;
        } else {
          submitButton.setAttribute('disabled', 'disabled');
          submitLabel.textContent = soldOutText;
        }
      }

      function syncOtherBuyboxes(variantId, variantTitle, variantPriceFormatted, variantSave, variantPerTest, variantFeatures, variantAvailable) {
        sectionRoot.querySelectorAll('[data-exseed-buybox]').forEach(function (otherBuybox) {
          if (otherBuybox === buybox) return;

          const matchingButton = otherBuybox.querySelector('.exseed-pdp-shell__option[data-variant-id="' + variantId + '"]');
          if (!matchingButton) return;

          otherBuybox.querySelectorAll('.exseed-pdp-shell__option').forEach(function (btn) {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-pressed', 'false');
          });

          matchingButton.classList.add('is-active');
          matchingButton.setAttribute('aria-pressed', 'true');

          const otherTitleTarget = otherBuybox.querySelector('[data-selected-title]');
          const otherPriceTarget = otherBuybox.querySelector('[data-selected-price]');
          const otherSaveTarget = otherBuybox.querySelector('[data-selected-save]');
          const otherPerTestTarget = otherBuybox.querySelector('[data-selected-per-test]');
          const otherPerTestWrapper = otherBuybox.querySelector('[data-selected-per-test-wrapper]');
          const otherFeaturesTarget = otherBuybox.querySelector('[data-selected-features]');
          const otherVariantInput = otherBuybox.querySelector('[data-selected-variant-id]');
          const otherSubmitButton = otherBuybox.querySelector('.exseed-pdp-shell__submit');
          const otherSubmitLabel = otherBuybox.querySelector('[data-add-to-cart-label]');

          if (otherTitleTarget) otherTitleTarget.textContent = variantTitle;
          if (otherPriceTarget) otherPriceTarget.textContent = variantPriceFormatted;

          if (otherSaveTarget) {
            otherSaveTarget.textContent = variantSave;
            otherSaveTarget.classList.toggle('is-hidden', !variantSave);
          }

          if (otherPerTestTarget && otherPerTestWrapper) {
            if (variantPerTest) {
              otherPerTestTarget.textContent = variantPerTest;
              otherPerTestWrapper.classList.remove('is-hidden');
            } else {
              otherPerTestTarget.textContent = '';
              otherPerTestWrapper.classList.add('is-hidden');
            }
          }

          if (otherVariantInput) {
            otherVariantInput.value = variantId;
          }

          renderFeatures(variantFeatures, otherFeaturesTarget);

          if (otherSubmitButton && otherSubmitLabel) {
            if (variantAvailable) {
              otherSubmitButton.removeAttribute('disabled');
              otherSubmitLabel.textContent = addToCartText;
            } else {
              otherSubmitButton.setAttribute('disabled', 'disabled');
              otherSubmitLabel.textContent = soldOutText;
            }
          }
        });
      }

      function updateBuyboxFromButton(button, updateUrl, syncOthers) {
        if (!button) return;

        optionButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

        const variantId = button.getAttribute('data-variant-id');
        const variantTitle = button.getAttribute('data-variant-title') || '';
        const variantPriceFormatted = button.getAttribute('data-variant-price-formatted') || '';
        const variantSave = button.getAttribute('data-variant-save') || '';
        const variantPerTest = button.getAttribute('data-variant-per-test') || '';
        const variantFeatures = button.getAttribute('data-variant-features') || '';
        const variantAvailable = button.getAttribute('data-variant-available') === 'true';
        const variantMediaId = button.getAttribute('data-variant-media-id') || '';

        if (titleTarget) titleTarget.textContent = variantTitle;
        if (priceTarget) priceTarget.textContent = variantPriceFormatted;

        if (saveTarget) {
          saveTarget.textContent = variantSave;
          saveTarget.classList.toggle('is-hidden', !variantSave);
        }

        if (perTestTarget && perTestWrapper) {
          if (variantPerTest) {
            perTestTarget.textContent = variantPerTest;
            perTestWrapper.classList.remove('is-hidden');
          } else {
            perTestTarget.textContent = '';
            perTestWrapper.classList.add('is-hidden');
          }
        }

        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        renderFeatures(variantFeatures, featuresTarget);
        refreshPaymentTerms();
        updateSubmitButtonState(variantAvailable);

        if (carousel && typeof carousel.exseedSetVariantMedia === 'function') {
          carousel.exseedSetVariantMedia(variantId, variantMediaId);
        }

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }

        if (syncOthers) {
          syncOtherBuyboxes(variantId, variantTitle, variantPriceFormatted, variantSave, variantPerTest, variantFeatures, variantAvailable);
        }
      }

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          updateBuyboxFromButton(button, true, true);
        });
      });

      if (form && !form.hasAttribute('data-exseed-submit-bound')) {
        form.setAttribute('data-exseed-submit-bound', 'true');
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          submitToCart(form, addToCartAction);
        }, true);
      }

      const activeButton = buybox.querySelector('.exseed-pdp-shell__option.is-active');
      if (activeButton) {
        updateBuyboxFromButton(activeButton, false, false);
      } else if (optionButtons.length > 0) {
        renderFeatures('', featuresTarget);
      }
    }

    function getVideoEmbedHtml(url, autoplay, muted) {
      var ap = autoplay ? 1 : 0;
      var mu = muted ? 1 : 0;
      var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/);
      if (ytMatch) {
        return '<iframe src="https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=' + ap + '&mute=' + mu + '&rel=0&modestbranding=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      }
      var vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) {
        return '<iframe src="https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=' + ap + '&muted=' + mu + '&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      }
      return '<video src="' + url + '"' + (autoplay ? ' autoplay' : '') + (muted ? ' muted' : '') + ' controls playsinline style="width:100%;height:100%;object-fit:cover;"></video>';
    }

    function getYoutubeThumbnail(url) {
      var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/);
      if (ytMatch) return 'https://img.youtube.com/vi/' + ytMatch[1] + '/hqdefault.jpg';
      return null;
    }

    var vcrModal = null;

    function openVideoModal(url) {
      if (!vcrModal) {
        vcrModal = document.createElement('div');
        vcrModal.className = 'exseed-vcr__modal';
        vcrModal.innerHTML =
          '<div class="exseed-vcr__modal-overlay"></div>' +
          '<div class="exseed-vcr__modal-inner">' +
            '<button class="exseed-vcr__modal-close" type="button" aria-label="Close">\u00d7</button>' +
            '<div class="exseed-vcr__modal-video"></div>' +
          '</div>';
        document.body.appendChild(vcrModal);
        vcrModal.querySelector('.exseed-vcr__modal-overlay').addEventListener('click', closeVideoModal);
        vcrModal.querySelector('.exseed-vcr__modal-close').addEventListener('click', closeVideoModal);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeVideoModal();
        });
      }
      vcrModal.querySelector('.exseed-vcr__modal-video').innerHTML = getVideoEmbedHtml(url, true);
      vcrModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeVideoModal() {
      if (!vcrModal) return;
      vcrModal.classList.remove('is-open');
      vcrModal.querySelector('.exseed-vcr__modal-video').innerHTML = '';
      document.body.style.overflow = '';
    }

    sectionRoot.querySelectorAll('[data-exseed-video-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.exseed-vcr__track');
      var dotsContainer = carousel.querySelector('[data-vcr-dots]');
      var prevBtn = carousel.querySelector('[data-vcr-prev]');
      var nextBtn = carousel.querySelector('[data-vcr-next]');
      var enablePopup = carousel.getAttribute('data-enable-popup') === 'true';

      if (!track) return;

      carousel.querySelectorAll('.exseed-vcr__thumb--auto[data-auto-thumb]').forEach(function (el) {
        var url = el.getAttribute('data-auto-thumb');
        var thumbUrl = getYoutubeThumbnail(url);
        if (thumbUrl) {
          var img = document.createElement('img');
          img.src = thumbUrl;
          img.alt = 'Video thumbnail';
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
          el.appendChild(img);
        }
      });

      var realSlides = Array.from(carousel.querySelectorAll('.exseed-vcr__slide'));
      var totalReal = realSlides.length;

      if (totalReal === 0) return;

      if (totalReal === 1) {
        var singleSlide = realSlides[0];
        var singleUrl = singleSlide.getAttribute('data-video-url');
        var singleInlineDiv = singleSlide.querySelector('.exseed-vcr__inline-video');
        var singlePlayBtn = singleSlide.querySelector('.exseed-vcr__play');
        singlePlayBtn.addEventListener('click', function () {
          if (enablePopup) {
            openVideoModal(singleUrl);
          } else {
            if (singleInlineDiv) {
              singleInlineDiv.innerHTML = getVideoEmbedHtml(singleUrl, true, false);
              singleInlineDiv.classList.add('is-playing');
              singlePlayBtn.style.display = 'none';
            }
          }
        });
        carousel.classList.add('is-ready');
        if (!enablePopup && singleUrl && singleInlineDiv) {
          singleInlineDiv.innerHTML = getVideoEmbedHtml(singleUrl, true, true);
          singleInlineDiv.classList.add('is-playing');
          singlePlayBtn.style.display = 'none';
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                  singleInlineDiv.innerHTML = '';
                  singleInlineDiv.classList.remove('is-playing');
                  singlePlayBtn.style.display = '';
                } else if (!singleInlineDiv.classList.contains('is-playing')) {
                  singleInlineDiv.innerHTML = getVideoEmbedHtml(singleUrl, true, true);
                  singleInlineDiv.classList.add('is-playing');
                  singlePlayBtn.style.display = 'none';
                }
              });
            }, { threshold: 0.4 }).observe(carousel);
          }
        }
        return;
      }

      var firstClone = realSlides[0].cloneNode(true);
      var lastClone = realSlides[totalReal - 1].cloneNode(true);
      firstClone.setAttribute('data-clone', 'true');
      lastClone.setAttribute('data-clone', 'true');
      firstClone.querySelectorAll('.exseed-vcr__inline-video').forEach(function (el) { el.innerHTML = ''; });
      lastClone.querySelectorAll('.exseed-vcr__inline-video').forEach(function (el) { el.innerHTML = ''; });

      track.appendChild(firstClone);
      track.insertBefore(lastClone, realSlides[0]);

      var currentIndex = 1;

      function getSlideOffset(index) {
        var allSlides = Array.from(track.querySelectorAll('.exseed-vcr__slide'));
        var slide = allSlides[index];
        if (!slide) return 0;

        var isMobile = window.innerWidth < 990;
        if (isMobile) {
          var viewport = carousel.querySelector('.exseed-vcr__viewport');
          var vpWidth = viewport ? viewport.offsetWidth : track.offsetWidth;
          var slideWidth = slide.offsetWidth;
          var centreOffset = (vpWidth - slideWidth) / 2;
          return slide.offsetLeft - centreOffset;
        }

        return slide.offsetLeft;
      }

      function setPosition(animate) {
        if (!animate) {
          track.classList.add('no-transition');
          track.style.transform = 'translateX(-' + getSlideOffset(currentIndex) + 'px)';
          void track.offsetWidth;
          track.classList.remove('no-transition');
        } else {
          track.classList.remove('no-transition');
          track.style.transform = 'translateX(-' + getSlideOffset(currentIndex) + 'px)';
        }
      }

      function buildDots() {
        if (!dotsContainer) return;
        var realIndex = currentIndex - 1;
        dotsContainer.innerHTML = '';
        for (var d = 0; d < totalReal; d++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'exseed-vcr__dot' + (d === realIndex ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (d + 1));
          (function (idx) {
            dot.addEventListener('click', function () {
              stopAllInline();
              currentIndex = idx + 1;
              setPosition(true);
              buildDots();
            });
          })(d);
          dotsContainer.appendChild(dot);
        }
      }

      function stopAllInline() {
        carousel.querySelectorAll('.exseed-vcr__inline-video.is-playing').forEach(function (el) {
          el.innerHTML = '';
          el.classList.remove('is-playing');
        });
        carousel.querySelectorAll('.exseed-vcr__play').forEach(function (btn) {
          btn.style.display = '';
        });
      }

      function playInline(slideEl, url, muted) {
        stopAllInline();
        var inlineDiv = slideEl.querySelector('.exseed-vcr__inline-video');
        var playBtn = slideEl.querySelector('.exseed-vcr__play');
        if (!inlineDiv) return;
        inlineDiv.innerHTML = getVideoEmbedHtml(url, true, muted);
        var stopBtn = document.createElement('button');
        stopBtn.type = 'button';
        stopBtn.className = 'exseed-vcr__inline-stop';
        stopBtn.setAttribute('aria-label', 'Stop video');
        stopBtn.innerHTML = '\u00d7';
        stopBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          stopAllInline();
        });
        inlineDiv.appendChild(stopBtn);
        inlineDiv.classList.add('is-playing');
        if (playBtn) playBtn.style.display = 'none';
      }

      function autoPlayCurrentSlide() {
        var allTrackSlides = Array.from(track.querySelectorAll('.exseed-vcr__slide'));
        var activeSlide = allTrackSlides[currentIndex];
        if (!activeSlide || activeSlide.getAttribute('data-clone') === 'true') return;
        if (activeSlide.querySelector('.exseed-vcr__inline-video.is-playing')) return;
        var url = activeSlide.getAttribute('data-video-url');
        if (!url || enablePopup) return;
        playInline(activeSlide, url, true);
      }

      realSlides.forEach(function (slideEl) {
        var url = slideEl.getAttribute('data-video-url');
        slideEl.querySelector('.exseed-vcr__play').addEventListener('click', function (e) {
          e.stopPropagation();
          if (enablePopup) {
            openVideoModal(url);
          } else {
            playInline(slideEl, url);
          }
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () { goPrev(); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () { goNext(); });
      }

      track.addEventListener('transitionend', function () {
        if (currentIndex === 0) {
          currentIndex = totalReal;
          setPosition(false);
        } else if (currentIndex === totalReal + 1) {
          currentIndex = 1;
          setPosition(false);
        }
        buildDots();
        autoPlayCurrentSlide();
      });

      function goNext() {
        stopAllInline();
        currentIndex++;
        setPosition(true);
      }

      function goPrev() {
        stopAllInline();
        currentIndex--;
        setPosition(true);
      }

      var touchStartX = 0;
      var touchStartY = 0;
      var isScrolling = null;

      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isScrolling = null;
      }, { passive: true });

      carousel.addEventListener('touchmove', function (e) {
        if (isScrolling === null) {
          var dx = Math.abs(e.touches[0].clientX - touchStartX);
          var dy = Math.abs(e.touches[0].clientY - touchStartY);
          isScrolling = dy > dx;
        }
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        if (isScrolling) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 44) {
          if (delta < 0) goNext();
          else goPrev();
        }
      }, { passive: true });

      window.addEventListener('resize', function () {
        setPosition(false);
      });

      setPosition(false);
      buildDots();
      carousel.classList.add('is-ready');

      autoPlayCurrentSlide();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              autoPlayCurrentSlide();
            } else {
              stopAllInline();
            }
          });
        }, { threshold: 0.4 }).observe(carousel);
      }
    });

    function initHowItWorksVideos() {
      sectionRoot.querySelectorAll('[data-hiw-video-trigger]').forEach(function (trigger) {
        if (trigger.hasAttribute('data-hiw-bound')) return;
        trigger.setAttribute('data-hiw-bound', 'true');
        trigger.addEventListener('click', function () {
          var url = trigger.getAttribute('data-video-url');
          var usePopup = trigger.getAttribute('data-popup') === 'true';
          if (!url) return;

          if (usePopup) {
            openVideoModal(url);
            return;
          }

          var inlineWrap = trigger.querySelector('.exseed-how-it-works__inline-video');
          var mediaWrap = trigger.querySelector('.exseed-how-it-works__video-media');
          var playBtn = trigger.querySelector('.exseed-how-it-works__play');
          if (!inlineWrap || !mediaWrap) return;

          inlineWrap.innerHTML = getVideoEmbedHtml(url, true);
          var closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'exseed-how-it-works__inline-close';
          closeBtn.setAttribute('aria-label', 'Close video');
          closeBtn.innerHTML = '\u00d7';
          closeBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            inlineWrap.innerHTML = '';
            inlineWrap.hidden = true;
            if (playBtn) playBtn.style.display = '';
          });
          inlineWrap.appendChild(closeBtn);
          inlineWrap.hidden = false;
          if (playBtn) playBtn.style.display = 'none';
        });
      });
    }

    sectionRoot.querySelectorAll('[data-exseed-buybox]').forEach(initBuybox);
    initHowItWorksVideos();
    initPressCarousels();

    updateLastMobileShellBlock();
    syncFixedSidebarPosition();

    window.addEventListener('resize', function () {
      updateLastMobileShellBlock();
      syncFixedSidebarPosition();
    });

    window.addEventListener('scroll', syncFixedSidebarPosition, { passive: true });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sectionRoot.style.transition = 'opacity 0.3s ease';
        sectionRoot.style.opacity = '1';
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initExseedPdpShell(document); });
} else {
  initExseedPdpShell(document);
}

document.addEventListener('shopify:section:load', function (e) { initExseedPdpShell(e.target); });

(function () {
  function initHFAutoplay(root) {
    root.querySelectorAll('.exseed-pdp-shell__hf-media-el[data-hf-autoplay="true"]').forEach(function (video) {
      video.muted = true;
      function tryPlay() {
        var p = video.play();
        if (p !== undefined) {
          p.catch(function () {});
        }
      }
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { tryPlay(); } else { video.pause(); }
          });
        }, { threshold: 0.2 });
        obs.observe(video);
      } else {
        tryPlay();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHFAutoplay(document); });
  } else {
    initHFAutoplay(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initHFAutoplay(e.target); });
})();
